<template>
  <b-modal id="helpModal" :hide-footer="true" :hide-header="false" class="modal__help">
    <div class="row modal__size">
      <div class="col-12 col-sm-5 text-center">
        <img class="modal__img" src="@/assets/ico-person.svg" alt="">
      </div>
      <div class="col-12 col-sm-7">
        <h1 class="text--black mb-xl-5 mb-2 mt-2 mt-sm-0">{{ $t("write")}} </h1>
        <b-form v-if="show" @submit.prevent="sendQuestion">
          <b-form-input
            type="text"
            v-model="support.name"
            required placeholder="Full Name"
            class="mb-3">
          </b-form-input>
          <b-form-input
            type="email"
            v-model="support.email"
            required placeholder="E-mail"
            class="mb-3">
          </b-form-input>
          <b-form-textarea
            v-model="support.body"
            placeholder="Write a message"
            :rows="3"
            :max-rows="6">
          </b-form-textarea>
          <span v-if="success" class="log__succes">
            {{ $t("contactUs.alert")}}
          </span>
          <b-btn variant="primary" size="sm" class="float-right" type="submit">
            {{ $t("send")}}
          </b-btn>
        </b-form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import support from '@/api/v1/support';

export default {
  props: ['askForHelp'],
  data() {
    return {
      show: true,
      support: {},
      success: false,
    };
  },
  methods: {
    sendQuestion() {
      const succ = () => { this.success = true; this.support = {}; };
      support.send(this.support, succ);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.modal {
  &__size {
  margin-bottom: 120px;
  }
  &__img {
    max-width: 300px;
    height: auto;
    @include media('<sm') {
      width: 200px;
    }
  }
}
.log__succes{
  display: block;
  text-align: center;
  margin-top: 10px;
  color: $color--green;
  font-size: 16px;
  @include media('<sm') {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Support/HelpModal.vue